module.exports = __webpack_public_path__ + "media/images/emblems/Nebikon_LU-ea0f898b01b036d18a89983cf8a87b4f.png";